import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { Counter } from './StockCounterStyledComponents'

const StockCounter = React.memo(({ show, count, ...props }) => {
  return show ? (
    <Counter {...props}>
      <FormattedMessage id='stockCounter.left' values={{ count }} />
    </Counter>
  ) : null
})

StockCounter.displayName = 'StockCounter'

StockCounter.propTypes = {
  show: PropTypes.bool,
  count: PropTypes.number
}

export default StockCounter
